
























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import PhoneInput from '@/components/molecules/PhoneInput/PhoneInput.vue';
import AddressFieldDropdown from '@/componentsV2/organisms/AddressFieldDropdown/AddressFieldDropdown.vue';
import MerchantIDTooltip from '@/components/MerchantIDTooltip/MerchantIDTooltip.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { getLabelInfo } from '@/utils/getLabelInfo';
import eventBus from '@/utils/eventBus';

import LocationsService from '@/api/LocationsService';

import { Business } from '@/store/modules/businessTypes';

export function locationFactory() {
  return {
    address: '',
    city: '',
    zip: '',
    state: '',
    phone: '',
    phoneCountryCode: '',
    phoneCountryIso: '',
    primary: false,
    addressAdditional: '',
    merchantId: '',
    fullAddress: ''
  };
}

@Component({
  components: {
    FilledButton,
    MerchantIDTooltip,
    AddressFieldDropdown,
    TextField,
    PhoneInput
  },
  computed: {
    tooltipTargetRef() {
      return this.$refs.tooltipTarget;
    }
  }
})
export default class LocationManager extends Vue {
  @Prop({ default: locationFactory() }) address?: any;
  @Prop() business?: Business;

  service = new LocationsService();
  loading: boolean = false;
  dirty: boolean = false;
  errors: string[] = [];
  mobileModalOpened = false;

  businessCountryIso =
    this.business && this.business.countryIso2
      ? this.business.countryIso2
      : 'US';

  phone = {
    code: this.address.phoneCountryCode,
    number: this.address.phone,
    iso: this.address.phoneCountryIso
      ? this.address.phoneCountryIso
      : this.businessCountryIso
  };

  handleCloseMobileModal() {
    this.mobileModalOpened = false;
  }

  handleTippyClick() {
    if (!this.$mobileCheck()) return;

    this.mobileModalOpened = true;
  }

  handleCloseTooltip() {
    const triggerEl = document.querySelector('[data-tippy="merchant-tooltip"]');

    if (triggerEl) {
      triggerEl.dispatchEvent(new Event('click'));
    }
  }

  selectAddress(address: any) {
    this.address.address = address.address;
    this.address.city = address.cityName;
    this.address.zip = address.postCode;
    this.address.state = address.stateCode;
    this.address.fullAddress = address.fullAddress;
  }

  updatePhone(value: any) {
    this.address.phone = value.number;
    this.address.phoneCountryCode = value.code;
    this.address.phoneCountryIso = value.iso;
  }

  async submit() {
    try {
      this.dirty = true;
      this.loading = true;

      if (!this.validData) return false;

      const response = this.address.id
        ? await this.service.edit(this.address.id, this.address)
        : await this.service.create(this.address);

      if (![200, 201].includes(response.status)) return;

      if (response.status === 201) {
        this.$notification('Location created');
      }
      if (response.status === 200) {
        this.$notification('Location updated');

        const phoneObj = {
          number: this.address.phone,
          code: this.address.phoneCountryCode,
          iso: this.address.phoneCountryIso
        };

        if (this.address.primary) {
          this.$store.dispatch('business/UPDATE_BUSINESS_PHONE', phoneObj);
        }
      }

      this.updatedBusinessLocations();

      eventBus.$emit('setSideModalVisible', false);
      eventBus.$emit('reloadLocations', { showLoader: false });
    } finally {
      this.loading = false;
    }
  }

  async updatedBusinessLocations() {
    const { data } = await this.service.getLocations();

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.business,
      businessLocations: data
    });
  }

  changeMID() {
    location.href = 'mailto:hello@twism.com';
  }

  handleClearAddress() {
    this.selectAddress({});
  }

  get validData() {
    const errors: string[] = [];

    if (!this.address.address || !this.address.address.length) {
      errors.push('address');
    }

    this.errors = errors;
    return !errors.length;
  }

  get initialAddressValue() {
    if (!this.address.id) return { value: null, label: null };

    const countryName = this.$store.getters[
      'internationalization/getCountrySettings'
    ].name;

    if (!this.address.countryName) {
      this.address.countryName = countryName;
    }

    const fullAddress = getLabelInfo(
      ['address', 'city', 'state', 'zip', 'countryName'],
      this.address
    );

    return {
      value: fullAddress,
      label: fullAddress,
      additionalInformation: {
        address: this.address.address,
        cityName: this.address.city,
        countryCode: this.address.phoneCountryIso,
        countryName: countryName,
        fullAddress: fullAddress,
        postCode: this.address.zip,
        stateCode: this.address.state,
        stateName: this.address.stateName
      }
    };
  }
}
